export default () => ({
    navOpen: false,
    activeMenuId: null,
    header: {
        el: null,
        bgColour: null,
        textColour: null,
        logoFilterInvert: null,
        hotLinksDisplay: null
    },

    init() {
        this.header.el = document.querySelector('header')
        const headerStyles = getComputedStyle(this.header.el)
        this.header.bgColour = headerStyles.getPropertyValue('--bg-colour')
        this.header.textColour = headerStyles.getPropertyValue('--text-colour')
        this.header.logoFilterInvert = headerStyles.getPropertyValue('--logo-filter-invert')
        this.header.hotLinksDisplay = headerStyles.getPropertyValue('--hot-links-display')

        window.addEventListener(
            'scroll',
            this.throttle(this.handleScroll.bind(this), 50)
        )

        this.handleScroll()
    },

    toggleNav(bool) {
        this.navOpen = bool ?? !this.navOpen

        const navIsStuck = this.navIsStuck()
        this.$refs.nav.classList.toggle('max-lg:!top-0', !navIsStuck)
        this.$refs.nav.classList.toggle('max-lg:!h-screen-dynamic', !navIsStuck)

        document.body.classList.toggle('overflow-hidden', this.navOpen)
        document.body.classList.toggle('lg:overflow-visible', this.navOpen)
    },
    toggleMenu(id) {
        if (!id) {
            this.activeMenuId = null
            throw Error('Missing menu ID.')
        }

        this.activeMenuId = id === this.activeMenuId ? null : id

        this.$nextTick(() => {
            document.body.classList.toggle(
                'overflow-hidden',
                this.activeMenuId && this.activeMenuId !== null
            )

            if (this.activeMenuId && this.activeMenuId !== null) {
                const headerRect = this.$root.getBoundingClientRect()
                const menu = document.querySelector(
                    `#menu-${this.activeMenuId}`
                )

                if (headerRect.top > 0) {
                    menu.classList.add('lg:!top-0')
                } else {
                    menu.classList.remove('lg:!top-0')
                }
            }
        })
    },
    closeMenu(e) {
        if (e.target.closest('.nav-menu-toggle')) {
            return
        }

        this.activeMenuId = null
        document.body.classList.remove('overflow-hidden')
    },
    navIsStuck() {
        const headerRect = this.header.el.getBoundingClientRect()
        return headerRect.top <= 1
    },
    throttle(callback, delay) {
        let waiting = false

        return () => {
            if (!waiting) {
                callback.call()
                waiting = true

                setTimeout(() => {
                    waiting = false
                }, delay)
            }
        }
    },
    handleScroll(e) {
        const scrollY = window.scrollY

        if (this.navIsStuck() && scrollY > 200) {
            this.header.el.style.setProperty('--bg-colour', '#ffffff')
            this.header.el.style.setProperty('--text-colour', '#000000')
            this.header.el.style.setProperty('--logo-filter-invert', '0')
            this.header.el.style.setProperty('--hot-links-display', '100')
        } else {
            this.header.el.style.setProperty(
                '--bg-colour',
                this.header.bgColour
            )
            this.header.el.style.setProperty(
                '--text-colour',
                this.header.textColour
            )
            this.header.el.style.setProperty(
                '--logo-filter-invert',
                this.header.logoFilterInvert
            )
            this.header.el.style.setProperty(
                '--hot-links-display',
                this.header.hotLinksDisplay
            )
        }
    },
})
